import { t } from 'i18next';

export enum UserLevel {
  TESTER = 'TESTER',
  ANALYST = 'ANALYST',
  ADMIN = 'ADMIN',
}

export const getUserLevelLabel = (level: UserLevel): string => {
  switch (level) {
    case UserLevel.TESTER:
      return t('userLevels.tester');
    case UserLevel.ANALYST:
      return t('userLevels.analyst');
    case UserLevel.ADMIN:
      return t('userLevels.admin');
  }
};

export const compareUserLevel = (source: UserLevel, target: UserLevel): -1 | 0 | 1 => {
  if (source === target) {
    return 0;
  }
  if (source === UserLevel.ADMIN) {
    return -1;
  }
  if (source === UserLevel.ANALYST) {
    return target === UserLevel.TESTER ? -1 : 1;
  }
  if (source === UserLevel.TESTER) {
    return 1;
  }
  return 0;
};
